/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import MuiCard from '@mui/material/Card';
import MuiCardActions from '@mui/material/CardActions';
import MuiCardContent from '@mui/material/CardContent';
import React from 'react';

import { Colors } from 'src/common/ui/base/Colors';
import { Spacing } from 'src/common/ui/base/Spacing';

export const Card = ({ children }: { children: React.ReactNode }) => (
  <MuiCard
    css={css`
      background-color: ${Colors.White};
      border-radius: 0;
      box-shadow: none;
      padding: 0;
      margin: 0;
      margin-bottom: ${Spacing.Unit4}px;

      &:last-child {
        margin-bottom: 0;
      }
    `}
  >
    {children}
  </MuiCard>
);

export const CardContent = ({ children }: { children: React.ReactNode }) => (
  <MuiCardContent
    css={css`
      padding: 0;
      margin: ${Spacing.Unit3}px;

      &:last-child {
        padding-bottom: 0;
      }
    `}
  >
    {children}
  </MuiCardContent>
);

export const CardActions = ({ children }: { children: React.ReactNode }) => (
  <MuiCardActions
    css={css`
      padding: 0;
      margin: ${Spacing.Unit3}px;
    `}
  >
    {children}
  </MuiCardActions>
);
